<template>
    <div>
        <!-- 本月运维事件 -->
        <Row style="margin-bottom: 20px;">
            <Col span="24">
                <Card >
                    <Row>
                        <Col span="20" class="title">本月运维事件</Col>
                        <Col style="float: right;">
                        	<Button @click="customizeModal = true" v-hasPermission="['operationKpiConfigurationManagement:reportConfiguration:add_modified_maintain']">自定义</Button>
                            <Button @click="selectTicketList" v-hasPermission="['operationKpiConfigurationManagement:reportConfiguration:add_maintain']">添加</Button>
                        </Col>
                    </Row>
                    <!-- 本月运维事件 -->
                 	<Table :no-data-text="$t('common.noData')" class="table-css" height="780" :columns="operationEvents" :data="operationEventsDate" :loading="operationEventsLoading">
                 		<template slot-scope="{row,index}" slot="delete">
			                <span @click="doDelete(index)">
			                    <Button type="error" size="small" @click="operationEventsDelModal = true" v-hasPermission="['operationKpiConfigurationManagement:reportConfiguration:delete_maintain']">{{ $t('ticket.list.delete') }}</Button>
			                </span>
			            </template>
                 	</Table>
                </Card>
            </Col>
        </Row>
        <!-- 上月待处理事件 -->
        <Row style="margin-bottom: 20px;">
            <Col span="24">
                <Card >
                    <Row>
                        <Col span="20" class="title" style="margin-bottom: 0px;">上月待处理事件</Col>
                    </Row>
                 	<!-- 上月待处理事件 -->
                 	<Row style="margin-bottom: 10px;">
                        <Col span="20" style="font-size: 13px;margin-bottom: 5px;margin-top: 5px;">根据上月度运维报告,贵公司还有部分优化事件待处理,如下</Col>
                        <Col style="float: right;">
                            <Button @click="selectEventsPendingModal" v-hasPermission="['operationKpiConfigurationManagement:reportConfiguration:add_pending_maintain']">添加</Button>
                        </Col>
                    </Row>
                    <Table :no-data-text="$t('common.noData')" class="table-css" height="780" :columns="eventsPending" :data="eventsPendingDate" :loading="eventsPendingLoading">
                 		<template slot-scope="{row,index}" slot="delete">
			                <span @click="doDeleteEventsPending(index)">
			                    <Button type="error" size="small" @click="eventsPendingDelModal = true" v-hasPermission="['operationKpiConfigurationManagement:reportConfiguration:delete_pending_maintain']">{{ $t('ticket.list.delete') }}</Button>
			                </span>
			            </template>
                 	</Table>
                </Card>
            </Col>
        </Row>
        <!-- 本月运维事件添加 -->
        <Modal v-model="operationEventsModal" title="添加" width="900px;" :loading="modalLoading" ok-text="添加" :mask-closable="false" :closable="false">
            <div slot="footer">
                <Button @click="cancel()">取消</Button>
                <Button type="primary" @click="handleSubmit()" :loading="addloading" :disabled="isDisable">添加</Button>
            </div>
            <Table :no-data-text="$t('common.noData')" class="table-css" ref="selection" :columns="columns" :loading="loading" :data="queryOperationEventsData" :height="400" @on-selection-change="getSelection"></Table>
        </Modal>
        <!-- 本月运维事件删除 -->
        <Modal v-model="operationEventsDelModal" width="360" :mask-closable="false">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
            </p>
            <div style="text-align:center">
                <p>{{ $t('alarms.common.sureDelete') }}{{ $t('alarms.common.what') }}?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="modal_loading" @click="removeOperationEvents()" :disabled="isDisableDelete">{{ $t('ticket.list.delete') }}</Button>
            </div>
        </Modal>
        <!-- 本月运维事件自定义 -->
        <Modal v-model="customizeModal" title="自定义" :loading="loadingCustomize" @on-ok="customizeSubmit('customizeForm')" @on-cancel="customizeReset('customizeForm')" :mask-closable="false">
            <Form ref="customizeForm" :model="customizeForm" :label-width="100" :rules="ruleValidate">
            	<!-- 时间 -->
                <FormItem label="时间" prop="yearMonth">
                    <DatePicker type="datetime" placeholder="请选择时间" v-model="customizeForm.yearMonth" style="width:300px;" @on-change="customizeForm.yearMonth=$event"></DatePicker>
                </FormItem>

                <!-- 响应时间 -->
                <FormItem label="响应时间" prop="responseTime">
                    <InputNumber :min="1" :max="3600" v-model="customizeForm.responseTime"></InputNumber> 秒
                </FormItem>

                <!-- 解决时间 -->
                <FormItem label="解决时间" prop="solutionTime">
                  <InputNumber :min="1" :max="3600" v-model="customizeForm.solutionTime"></InputNumber> 秒
                </FormItem>

                <!-- 级别 -->
                <FormItem label="级别" prop="priority">
                    <Select v-model="customizeForm.priority" style="width:300px;">
                        <Option :value="item.id" v-for="item in priorityList" v-bind:key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 事件进度 -->
                <FormItem label="事件进度" prop="eventProcess">
                    <Select v-model="customizeForm.eventProcess" style="width:300px;">
                        <Option :value="item.name" v-for="item in eventProcessList" v-bind:key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                 <!-- 问题类型 -->
                <FormItem label="问题类型" prop="ticketCategory">
                    <Select v-model="customizeForm.ticketCategory" style="width:300px;">
                        <Option :value="item.id" v-for="item in ticketCategoryList" v-bind:key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 事件描述 -->
                <FormItem label="事件描述" prop="describe">
                    <Input v-model="customizeForm.describe" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="Enter something..." style="width:300px;"></Input>
                </FormItem>
            </Form>
        </Modal>
        <!--分割线-->
        <!-- 上月待处理事件添加 -->
        <Modal v-model="eventsPendingModal" title="添加" width="900px;" :loading="eventsPendingModalLoading" ok-text="添加" :mask-closable="false" :closable="false">
            <div slot="footer">
                <Button @click="cancelEventsPending()">取消</Button>
                <Button type="primary" @click="eventsPendingHandleSubmit()" :loading="eventsPendingAddloading" :disabled="eventsPendingIsDisable">添加</Button>
            </div>
            <Table :no-data-text="$t('common.noData')" class="table-css" ref="selection" :columns="eventsPendingColumns" :loading="eventsPendingLoadingAdd" :data="queryEventsPendingData" :height="400" @on-selection-change="getSelectionEventsPending"></Table>
        </Modal>
        <!-- 上月待处理事件删除 -->
        <Modal v-model="eventsPendingDelModal" width="360" :mask-closable="false">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
            </p>
            <div style="text-align:center">
                <p>{{ $t('alarms.common.sureDelete') }}{{ $t('alarms.common.what') }}?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="eventsPendingDelLoading" @click="removeEventsPending()" :disabled="isDisableEventsPending">{{ $t('ticket.list.delete') }}</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    var operationMaintenanceVue = {}
    export default {
        name: 'OperationMaintenance',
        data(){
            return {
                priotityLists:['P1','P2','P3','P4'],
                ticketCategoryLists:['基础架构告警事件','安全告警事件','账单告警事件','','公司贡献','变更请求','定时任务管理','服务申请'],
                accountIdList:[],
                reportId:0,
                companyId:0,
                reportDate:'',  //初始化传参
            	// 自定义
            	loadingCustomize: true,
                customizeModal: false,
                ticketCategoryList:[{
                    id:0,
                    name:'基础架构告警事件'
                },
                {
                    id:1,
                    name:'安全告警事件'
                },
                {
                    id:2,
                    name:'账单告警事件'
                },
                {
                    id:4,
                    name:'公司贡献'
                },
                {
                    id:5,
                    name:'变更请求'
                },
                {
                    id:6,
                    name:'定时任务管理'
                },
                {
                    id:7,
                    name:'服务申请'
                }],
                priorityList:[
                {
                    id:0,
                    name:'P1'
                },
                {
                    id:1,
                    name:'P2'
                },{
                    id:2,
                    name:'P3'
                },
                {
                    id:3,
                    name:'P4'
                }],  // 级别
                eventProcessList:[
                {
                    id:0,
                    name:'等待处理'
                },
                {
                    id:1,
                    name:'正在处理'
                },
                {
                    id:2,
                    name:'手动关闭'
                },
                {
                    id:3,
                    name:'等待授权'
                },
                {
                    id:4,
                    name:'自动完成'
                },
                {
                    id:5,
                    name:'审核中'
                },
                {
                    id:6,
                    name:'审核不通过'
                },
                {
                    id:7,
                    name:'审批通过'
                },
                {
                    id:8,
                    name:'确认中'
                },
                {
                    id:9,
                    name:'已确认'
                },
                {
                    id:10,
                    name:'自动关闭'
                }], //事件进度
                customizeForm: {
                    priority: '',
                    yearMonth:'',
                    describe:'',
                    eventProcess:'',
                    ticketCategory:'',
                    responseTime: 0,
                    solutionTime: 0
                },
                ruleValidate: {
                    priority: [
                        { required: true, message: '请选择级别', trigger: 'change',type:'number'  }
                    ],
                    ticketCategory: [
                        { required: true, message: '请选择问题类型', trigger: 'change',type:'number'  }
                    ],
                    eventProcess: [
                        { required: true, message: '请选择事件进度', trigger: 'change'}
                    ],
                    yearMonth: [
                        { required: true, message: '请选择时间'}
                    ],
                    describe: [
                        { required: true, message: '请输入事件描述', trigger: 'blur'},
                        { type: 'string', max: 10000, message: '最多输入10000个字符', trigger: 'blur' }
                    ],
                    responseTime: [
                        { required: true, message: '请输入响应时间', trigger: 'blur',type: 'number'}
                    ],
                    solutionTime: [
                      { required: true, message: '请输入解决时间', trigger: 'blur',type: 'number'}
                    ]
                },
                //本月运维事件 添加
            	selection: [],
                operationEventsModal: false,
                modalLoading: true,
                loading: false,
                addloading:false,
                isDisable: true,
                columns: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '时间',
                    key: 'ticketTime'
                },
                {
                    title: '级别',
                    key: 'priorityId'
                },
                {
                    title: '事件描述',
                    key: 'ticketDescribe'
                },
                {
                    title: '事件进度',
                    key: 'ticketProgress'
                }],
                newQueryOperationEvents:[],
                //本月运维事件 删除
                name:'',
                modal_loading: false,
                operationEventsDelModal:false,
                isDisableDelete: false,
                //本月运维事件
            	operationEventsLoading:false,
                operationEvents: [
                {
                    title: '时间',
                    key: 'ticketTime'
                },
                {
                    title: '级别',
                    key: 'priorityId'
                },
                {
                    title: '事件描述',
                    key: 'ticketDescribe'
                },
                {
                    title: '事件进度',
                    key: 'ticketProgress'
                },
                {
                	title:'操作',
                	slot:'delete'
                }],
                newOperationEventsDate:[],
                operationEventsDate:[],
                queryOperationEventsData: [],
                //上月待处理事件 添加
            	selectionEventsPending: [],
                eventsPendingModal: false,
                eventsPendingModalLoading: true,
                eventsPendingLoadingAdd: false,
                eventsPendingAddloading:false,
                eventsPendingIsDisable: true,
                eventsPendingColumns: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '待优化事件',
                    key: 'ticketDescribe'
                },
                {
                    title: '所属类型',
                    key: 'ticketCategory'
                },
                {
                    title: '问题原因',
                    key: 'ticketReasons'
                },
                {
                    title: '事件进度',
                    key: 'ticketProgress'
                }],
                newQueryEventsPending:[],
                //上月待处理事件 删除
                eventsPendingName:'',
                eventsPendingDelLoading: false,
                eventsPendingDelModal:false,
                isDisableEventsPending: false,
                //上月待处理事件
            	eventsPendingLoading:false,
                eventsPending: [
                {
                    title: '待优化事件',
                    key: 'ticketDescribe'
                },
                {
                    title: '所属类型',
                    key: 'ticketCategory'
                },
                {
                    title: '问题原因',
                    key: 'ticketReasons'
                },
                {
                    title: '事件进度',
                    key: 'ticketProgress'
                },
                {
                	title:'操作',
                	slot:'delete'
                }],
                eventsPendingDate:[],
                queryEventsPendingData: []
            }
        },
        beforeCreate: function() {
            operationMaintenanceVue = this
        },
        mounted () {
            operationMaintenanceVue.selectOperationEvents();
            operationMaintenanceVue.selectEventsPending();
        },
        created(){
            // 初始化参数
            this.accountIdList=JSON.parse(this.$route.query.accountIdList);
            this.reportId=Number(this.$route.query.reportId);
            this.companyId=Number(this.$route.query.companyId);
            this.reportDate=this.$route.query.reportDate;
        },
        methods: {
        	/*****************本月运维事件*************************************/
        	// 表格
            selectOperationEvents:function(){
                this.operationEventsLoading = true;
                this.$api.reportTicket.selectReportTicketList({
                    "reportId": this.reportId
                })
                .then(res => {
                    this.operationEventsDate=[];
                    this.newOperationEventsDate = res.data;
                    for(var i=0;i<this.newOperationEventsDate.length;i++){
                        // 级别
                        if(this.newOperationEventsDate[i].priorityId==0){
                            this.newOperationEventsDate[i].priorityId='P1';
                        }else if(this.newOperationEventsDate[i].priorityId==1){
                            this.newOperationEventsDate[i].priorityId='P2';
                        }else if(this.newOperationEventsDate[i].priorityId==2){
                            this.newOperationEventsDate[i].priorityId='P3';
                        }else if(this.newOperationEventsDate[i].priorityId==3){
                            this.newOperationEventsDate[i].priorityId='P4';
                        }

                        if(this.newOperationEventsDate[i].type==0){
                            this.operationEventsDate.push(this.newOperationEventsDate[i])
                        }
                    }
                    this.operationEventsLoading = false;
                })
            },
            // 查询本月运维事件
            selectTicketList:function(){
                this.operationEventsModal=true;
                this.loading=true;
                this.$api.reportTicket.selectTicketList({
                    "reportId": this.reportId
                })
                .then(res => {
                    this.queryOperationEventsData = res.data;
                    for(var i=0;i<this.queryOperationEventsData.length;i++){
                        // 级别
                        if(this.queryOperationEventsData[i].priorityId==0){
                            this.queryOperationEventsData[i].priorityId='P1';
                        }else if(this.queryOperationEventsData[i].priorityId==1){
                            this.queryOperationEventsData[i].priorityId='P2';
                        }else if(this.queryOperationEventsData[i].priorityId==2){
                            this.queryOperationEventsData[i].priorityId='P3';
                        }else if(this.queryOperationEventsData[i].priorityId==3){
                            this.queryOperationEventsData[i].priorityId='P4';
                        }
                    }
                    this.loading = false;
                })
            },
            // 转换等级
            getPriotityId:function(priorityStr){
                for(var i=0;i<this.priotityLists.length;i++){
                    if(priorityStr==this.priotityLists[i]){
                        return i;
                    }
                }
                return -1;
            },
            // 当前选择checkbox
            getSelection: function (selection) {
                this.selection = selection;
                // 清空数组
                this.newQueryOperationEvents = [];
                for (var i = 0; i < this.selection.length; i++) {
                    var priorityId=this.getPriotityId(this.selection[i].priorityId);
                    var NewQueryOperationEventsCopy = new Object();
                    NewQueryOperationEventsCopy.reportId = this.selection[i].reportId;
                    NewQueryOperationEventsCopy.ticketId = this.selection[i].ticketId;
                    NewQueryOperationEventsCopy.monitorIndex = this.selection[i].monitorIndex;
                    NewQueryOperationEventsCopy.ticketDescribe = this.selection[i].ticketDescribe;
                    NewQueryOperationEventsCopy.ticketReasons = this.selection[i].ticketReasons;
                    NewQueryOperationEventsCopy.ticketProgress = this.selection[i].ticketProgress;
                    NewQueryOperationEventsCopy.ticketTime = this.selection[i].ticketTime;
                    NewQueryOperationEventsCopy.responseTime = this.selection[i].responseTime;
                    NewQueryOperationEventsCopy.solutionTime = this.selection[i].solutionTime;
                    NewQueryOperationEventsCopy.priorityId = priorityId;
                    NewQueryOperationEventsCopy.ticketCategory = this.selection[i].ticketCategory;
                    NewQueryOperationEventsCopy.type = 0;
                    this.newQueryOperationEvents.push(NewQueryOperationEventsCopy);
                }

                // 选了数据 可以点击下一步
                if (this.newQueryOperationEvents.length == 0) {
                    this.isDisable = true;
                } else {
                    this.isDisable = false;
                }
            },
            // 添加
            handleSubmit: function () {
                this.addloading=true;
                this.$api.reportTicket.addReportTicket({
                    "reportId": this.reportId,
                    "reportTicketDTOS":this.newQueryOperationEvents
                }).then(res => {
                    setTimeout(() => {
                        operationMaintenanceVue.selectOperationEvents();
                        this.modalLoading = false;
                        this.$nextTick(() => {
                            this.modalLoading = true;
                        });
                        this.$Message.success('添加成功');
                        this.queryOperationEventsData=[];
                        this.newQueryOperationEvents=[];
                        this.operationEventsModal = false;
                        this.isDisable = true;
                        this.addloading=false;
                    }, 1000);
                })
            },
             // 取消
            cancel: function () {
                this.isDisable = true;
                this.addloading=false;
                this.operationEventsModal = false;
                this.queryOperationEventsData=[];
                this.newQueryOperationEvents=[];
            },
            // 删除
            /****************************************************/
            doDelete: function(index){
                this.lineIndex=index;
                this.name=this.operationEventsDate[index].name;
            },
            removeOperationEvents: function(){
                this.isDisableDelete = true;  //开始可以点击
                var lineIndex=this.lineIndex;
                //删除
                this.$api.reportTicket.deleteReportTicket({
                    "id":this.operationEventsDate[lineIndex].id
                })
                .then(res => {
                    this.modal_loading = true;
                    setTimeout(() => {
                        // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
                        //21条  3页  2*10+1时删除
                        if(lineIndex==0&&((this.current-1)*this.pageSize+1)==this.dataTotal){
                            this.current=this.current-1;
                        }
                        this.dataTotal=this.dataTotal-1;
                        operationMaintenanceVue.selectOperationEvents();
                        this.isDisableDelete = false;
                        this.modal_loading = false;
                        this.operationEventsDelModal = false;
                        this.$Message.success('删除成功');
                    }, 1000);
                })
            },
            /*****************自定义*************************************/
            customizeSubmit: function (name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        // 添加
                        this.$api.reportTicket.addReportTicket({
                            "reportId": this.reportId,
                            "ticketTime": this.customizeForm.yearMonth,
                            "priorityId": this.customizeForm.priority,
                            "ticketProgress": this.customizeForm.eventProcess,
                            "ticketDescribe":this.customizeForm.describe,
                            "ticketCategory":this.customizeForm.ticketCategory,
                            "responseTime":this.customizeForm.responseTime,
                            "solutionTime":this.customizeForm.solutionTime,
                            "type" : 0,
                            "reportTicketDTOS": []
                        })
                        .then(res => {
                            setTimeout(() => {
                                operationMaintenanceVue.selectOperationEvents();
                                this.$refs[name].resetFields();
                                this.loadingCustomize = false;
                                this.$nextTick(() => {
                                    this.loadingCustomize = true;
                                });
                                this.$Message.success('添加成功');
                                this.customizeModal = false;
                            }, 1000);
                        })
                    } else {
                        this.loadingCustomize = false;
                        setTimeout(() => {
                            this.loadingCustomize = true
                        }, 0)
                        this.$Message.error('添加失败');
                    }
                });
            },
            customizeReset: function (name) {
                this.$refs[name].resetFields();
            },
            /*****************上月待处理事件************************************************/
            // 表格
            selectEventsPending:function(){
                this.eventsPendingLoading = true;
                this.$api.reportTicket.selectReportTicketList({
                    "reportId":this.reportId
                })
                .then(res => {
                    this.eventsPendingDate=[];
                    this.newEventsPendingDate = res.data;
                    for(var i=0;i<this.newEventsPendingDate.length;i++){
                        // 所属类型
                        if(this.newEventsPendingDate[i].ticketCategory==0){
                            this.newEventsPendingDate[i].ticketCategory='基础架构告警事件';
                        }else if(this.newEventsPendingDate[i].ticketCategory==1){
                            this.newEventsPendingDate[i].ticketCategory='安全告警事件';
                        }else if(this.newEventsPendingDate[i].ticketCategory==2){
                            this.newEventsPendingDate[i].ticketCategory='账单告警事件';
                        }else if(this.newEventsPendingDate[i].ticketCategory==4){
                            this.newEventsPendingDate[i].ticketCategory='公司贡献';
                        }else if(this.newEventsPendingDate[i].ticketCategory==5){
                            this.newEventsPendingDate[i].ticketCategory='变更请求';
                        }else if(this.newEventsPendingDate[i].ticketCategory==6){
                            this.newEventsPendingDate[i].ticketCategory='定时任务管理';
                        }else if(this.newEventsPendingDate[i].ticketCategory==7){
                            this.newEventsPendingDate[i].ticketCategory='服务申请';
                        }

                        if(this.newEventsPendingDate[i].type==1){
                            this.eventsPendingDate.push(this.newEventsPendingDate[i])
                        }
                    }
                    this.eventsPendingLoading = false;
                })
            },
            // 上月待处理事件
            selectEventsPendingModal:function(){
                this.eventsPendingModal=true;
                this.eventsPendingLoadingAdd=true;
                this.$api.reportTicket.selectTicketList({
                    "reportId": this.reportId
                })
                .then(res => {
                    this.queryEventsPendingData = res.data;
                    for(var i=0;i<this.queryEventsPendingData.length;i++){
                        // 所属类型
                        if(this.queryEventsPendingData[i].ticketCategory==0){
                            this.queryEventsPendingData[i].ticketCategory='基础架构告警事件';
                        }else if(this.queryEventsPendingData[i].ticketCategory==1){
                            this.queryEventsPendingData[i].ticketCategory='安全告警事件';
                        }else if(this.queryEventsPendingData[i].ticketCategory==2){
                            this.queryEventsPendingData[i].ticketCategory='账单告警事件';
                        }else if(this.queryEventsPendingData[i].ticketCategory==4){
                            this.queryEventsPendingData[i].ticketCategory='公司贡献';
                        }else if(this.queryEventsPendingData[i].ticketCategory==5){
                            this.queryEventsPendingData[i].ticketCategory='变更请求';
                        }else if(this.queryEventsPendingData[i].ticketCategory==6){
                            this.queryEventsPendingData[i].ticketCategory='定时任务管理';
                        }else if(this.queryEventsPendingData[i].ticketCategory==7){
                            this.queryEventsPendingData[i].ticketCategory='服务申请';
                        }
                    }
                    this.eventsPendingLoadingAdd = false;
                })
            },
             // 转换问题类型
            getTicketCategory:function(ticketCategoryStr){
                for(var i=0;i<this.ticketCategoryLists.length;i++){
                    if(ticketCategoryStr==this.ticketCategoryLists[i]){
                        return i;
                    }
                }
                return -1;
            },
            // 当前选择checkbox
            getSelectionEventsPending: function (selection) {
                this.selectionEventsPending = selection;
                // 清空数组
                this.newQueryEventsPending = [];
                for (var i = 0; i < this.selectionEventsPending.length; i++) {
                    var ticketCategory=this.getTicketCategory(this.selectionEventsPending[i].ticketCategory);
                    var NewQueryEventsPendingCopy = new Object();
                    NewQueryEventsPendingCopy.reportId = this.selectionEventsPending[i].reportId;
                    NewQueryEventsPendingCopy.ticketId = this.selectionEventsPending[i].ticketId;
                    NewQueryEventsPendingCopy.ticketDescribe = this.selectionEventsPending[i].ticketDescribe;
                    NewQueryEventsPendingCopy.ticketReasons = this.selectionEventsPending[i].ticketReasons;
                    NewQueryEventsPendingCopy.ticketProgress = this.selectionEventsPending[i].ticketProgress;
                    NewQueryEventsPendingCopy.ticketTime = this.selectionEventsPending[i].ticketTime;
                    NewQueryEventsPendingCopy.responseTime = this.selectionEventsPending[i].responseTime;
                    NewQueryEventsPendingCopy.solutionTime = this.selectionEventsPending[i].solutionTime;
                    NewQueryEventsPendingCopy.priorityId = this.selectionEventsPending[i].priorityId;
                    NewQueryEventsPendingCopy.ticketCategory = ticketCategory;
                    NewQueryEventsPendingCopy.type = 1;
                    this.newQueryEventsPending.push(NewQueryEventsPendingCopy);
                }

                // 选了数据 可以点击下一步
                if (this.newQueryEventsPending.length == 0) {
                    this.eventsPendingIsDisable = true;
                } else {
                    this.eventsPendingIsDisable = false;
                }
            },
            // 添加
            eventsPendingHandleSubmit: function () {
                this.eventsPendingAddloading=true;
                this.$api.reportTicket.addReportTicket({
                    "reportId": this.reportId,
                    "reportTicketDTOS":this.newQueryEventsPending
                }).then(res => {
                    setTimeout(() => {
                        operationMaintenanceVue.selectEventsPending();
                        this.eventsPendingModalLoading = false;
                        this.$nextTick(() => {
                            this.eventsPendingModalLoading = true;
                        });
                        this.$Message.success('添加成功');
                        this.queryEventsPendingData=[];
                        this.newQueryEventsPending=[];
                        this.eventsPendingModal = false;
                        this.eventsPendingIsDisable = true;
                        this.eventsPendingAddloading=false;
                    }, 1000);
                })
            },
             // 取消
            cancelEventsPending: function () {
                this.eventsPendingAddloading=false;
                this.eventsPendingIsDisable = true;
                this.eventsPendingModal = false;
                this.queryEventsPendingData=[];
                this.newQueryEventsPending=[];
            },
            // 删除
            /****************************************************/
            doDeleteEventsPending: function(index){
                this.lineIndex=index;
                this.eventsPendingName=this.eventsPendingDate[index].name;
            },
            removeEventsPending: function(){
                this.isDisableEventsPending = true;  //开始可以点击
                var lineIndex=this.lineIndex;
                //删除
                this.$api.reportTicket.deleteReportTicket({"id":this.eventsPendingDate[lineIndex].id})
                .then(res => {
                    this.eventsPendingDelLoading = true;
                    setTimeout(() => {
                        // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
                        //21条  3页  2*10+1时删除
                        if(lineIndex==0&&((this.current-1)*this.pageSize+1)==this.dataTotal){
                            this.current=this.current-1;
                        }
                        this.dataTotal=this.dataTotal-1;
                        operationMaintenanceVue.selectEventsPending();
                        this.isDisableEventsPending = false;
                        this.eventsPendingDelLoading = false;
                        this.eventsPendingDelModal = false;
                        this.$Message.success('删除成功');
                    }, 1000);
                })
            }
        }
    }
</script>

<style scoped>
    .title
    {
        font-size:14px;
        font-weight: 600;
        float:left;
        color:#000;
        margin-bottom: 30px;
    }
	/* 滚动条 */
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #ccc;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-track {
        background: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-corner {
        background-color: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowX{
        overflow-x: hidden !important;
    }
    .title
    {
        font-size:13px;
        font-weight: 600;
        float:left;
        color:#000;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/operation_kpi_configuration_management/operation_report/report_configuration/OperationMaintenance.vue